import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormField, Grid, Select, Text, TextArea, TextInput } from "grommet";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import Flag from "../components/Flag";
import NavigateToPath from "../components/NavigateToPath";
import ThemeBuilder from "../components/ThemeBuilder";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import TeamDetails from "./TeamDetails";
import { createTeam, CreateTeamRequest } from "./TeamsStore";

const CreateTeam = () => {
    let [organization, setOrganization] = React.useState({} as Organization);

    let [team, setTeam] = React.useState({} as CreateTeamRequest);

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    let navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createTeam(team).then(
            (result) => {
                navigate(`/teams/${result.teamID}`);
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (team) => {
        setTeam({ ...team, organizationID: organization.id });
    };

    React.useEffect(() => {
        setTeam({ ...team, organizationID: organization.id });
    }, [organization.id]);

    return (
        <div>
            <Box direction="row">
                <h1>Add Team </h1>
                <NavigateToPath path="/teams/create"></NavigateToPath>
            </Box>
            <Box width={{ max: "400px" }} pad="small" round="5px" background={"background"}>
                <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
                <TeamDetails team={team} isBusy={isCreating} onChange={onChange}></TeamDetails>
                <br />
                <Box direction="row">
                    {/* @ts-ignore */}
                    <CustomButton primary icon={<FontAwesomeIcon size="xl" icon={["fad", "users-medical"]}></FontAwesomeIcon>} onClick={create} disabled={isCreating || !team.name || !(team.logoUri || team.logoContent) || !team.organizationID} label="Create"></CustomButton>
                </Box>

                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateTeam;
